import {useAuthContext} from "../../contexts/auth";
import {buildSlug, updateQueryString} from "../../util/url";
import {useRouter} from "next/router";

// @material-ui/core components
import {makeStyles} from "tss-react/mui";

// core components
import Button from "../CustomButtons/Button";
import Image from "next/image.js";
import Link from "next/link.js";

import styles from "../../styles/jss/nextjs-material-kit/pages/forumsStyle.js";

// local assets
import ageIcon from "../../public/img/forums/icons/ageIcon.png";
import postsIcon from "../../public/img/forums/icons/postsIcon.png";
import timeIcon from "../../public/img/forums/icons/timeIcon.png";
import userPlaceholder from "../../public/img/no_profile.png";

const useStyles = makeStyles()(styles);

export default function ForumsProfileQuickView(props) {
    const { classes, cx } = useStyles();
    const { auth } = useAuthContext();
    const router = useRouter();

    const { id, firstName, position, image, age, posts, createdDate, profile_link: profileLink, forums = [] } = props.data;

    const createdDateFormatted = createdDate ?new Date(createdDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) : null;

    const handleProfileClick = async () => {
        if (auth.user == null) {
            await router.push(updateQueryString(updateQueryString(router.asPath, "login", null), "redirectUrl", router.asPath));
        }
        else {
          await router.push(profileLink);
        }
    }

    return (
        <div className={classes.quickViewContainer}>
            <div className={cx(classes.modalContent + " " + classes.quickViewContent)}>
                <div className={classes.quickViewHeader}>
                    <Image className={classes.quickViewImage} src={image || userPlaceholder} alt={"apprentice-profile-image"} width={100} height={100} />
                    <div className={classes.quickViewAccountData}>
                        <p className={classes.quickViewApprenticeName}>{firstName}</p>
                        <p className={classes.quickViewApprenticeTitle}>{position}</p>
                        <div className={cx(classes.quickViewIcons + " " + classes.desktopView)}>
                            {!!age && 
                            <>
                                <Image className={classes.quickViewIcon} src={ageIcon} alt={"age-birthday-cake-icon"} width={20} height={20} />
                                <p className={classes.quickViewDataText}>{age}yo</p>
                            </>}
                            {!!posts && 
                            <>
                                <Image className={classes.quickViewIcon} src={postsIcon} alt={"posts-icon"} width={20} height={20} />
                                <p className={classes.quickViewDataText}>{posts} posts</p>
                            </>}
                            {!!createdDate && 
                            <>
                                <Image className={classes.quickViewIcon} src={timeIcon} alt={"time-icon"} width={20} height={20} />
                                <p className={classes.quickViewDataText}>Joined {createdDateFormatted}</p>
                            </>}
                        </div>
                    </div>
                </div>
                <div className={cx(classes.quickViewIcons + " " + classes.mobileView)}>
                    {!!age && <>
                        <Image className={classes.quickViewIcon} src={ageIcon} alt={"age-birthday-cake-icon"} width={20} height={20} />
                        <p className={classes.quickViewDataText}>{age}yo</p>
                    </>}
                    {!!posts && <>
                    <Image className={classes.quickViewIcon} src={postsIcon} alt={"posts-icon"} width={20} height={20} />
                    <p className={classes.quickViewDataText}>{posts} posts</p>
                    </>}
                    {!!createdDate && <>
                    <Image className={classes.quickViewIcon} src={timeIcon} alt={"time-icon"} width={20} height={20} />
                    <p className={classes.quickViewDataText}>Joined {createdDateFormatted}</p>
                    </>}
                </div>
                {forums?.length > 0 && <>
                    <div className={classes.quickViewCommunitiesContainer}>
                        <h3 className={classes.quickViewCommunitiesTitle}>Active communities</h3>
                        <div className={classes.quickViewCommunities}>
                            {forums?.length > 3 ?
                              <>
                                  <Link className={classes.quickViewCommunityLink} href={`/community/${buildSlug(forums[0].name)}-${forums[0].subCatId}`} key={forums[0].subCatId}>
                                      <p className={classes.quickViewCommunityLinkText}>{forums[0]}</p>
                                  </Link>
                                  <Link className={classes.quickViewCommunityLink} href={`/community/${buildSlug(forums[1].name)}-${forums[1].subCatId}`} key={forums[1].subCatId}>
                                      <p className={classes.quickViewCommunityLinkText}>{forums[1]}</p>
                                  </Link>
                                  <div className={classes.quickViewCommunityLink}>
                                      <p className={classes.quickViewCommunityLinkText}>+{forums.length - 1} more</p>
                                  </div>
                              </> :
                              forums.map((community) => {
                                  return (
                                    <Link className={classes.quickViewCommunityLink} href={`/community/${buildSlug(community.name)}-${community.subCatId}`} key={community.subCatId}>
                                        <p className={classes.quickViewCommunityLinkText}>{community.name}</p>
                                    </Link>
                                  )
                              })}
                        </div>
                    </div>
                </>}
                {!!profileLink && <div className={classes.quickViewButtonContainer}>
                    <Button className={cx(classes.darkButton + " " + classes.smallButton + " " + classes.quickViewButton)} onClick={handleProfileClick}>View full profile</Button>
                </div>}

            </div>

        </div>
    )
}

